import React, { useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Avatar, Button, Input, Modal, Spin, Tooltip } from "antd";
import { SearchOutlined, TagFilled } from "@ant-design/icons";
import { Space, Table, Tag } from "antd";
import {
  CircleTickIcon,
  CompletedCaseStatus,
  CPUIcon,
  CreateCaseIcon,
  EmptyCircleIcon,
  Error,
  PendingCaseStatus,
  Tick,
  UploadFileIcon,
  ViewDetailsIcon,
} from "icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { UseApiCallV2, useDebounce } from "hooks";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { UploadFilesModal } from "./uploadFilesModal";
import { dateTimeFormatted, getDatatableWidth } from "utils/helpers";
import moment from "moment";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { localAssetsObj } from "pages/cases-detail/constants";

export const AttachmentsTable = ({
  refetchDetail,
  legalDocuments,
  isLoading,
  refetchLegalDocs,
  searchAssets,
  refetchAllUploadedFiles,
  dropdownsListObj,
  collapseOpen,
  tableHeading,
  refetchCount,
}) => {
  const { translator } = useLanguageTranslator();
  const legalDocsValuesTrans = translator("caseDetail.legalDocs");
  const [openUploadFileModal, setOpenUploadFileModal] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState({});
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [userSearch, setUserSearch] = useState("");
  const [selectedRecord, setSelectedRecord] = useState({});
  const deboucedSearch = useDebounce(userSearch, 500);

  const { caseId } = useParams();
  // const {
  //   data: legalDocuments,
  //   isLoading,
  //   refetch: refetchLegalDocs,
  // } = UseApiCallV2({
  //   url: "/get_all_uploads",
  //   method: "POST",
  //   paramsData: {
  //     case_id: caseId,
  //   },
  // });
  function getObjecstWithName({ apiData }) {
    if (!apiData || !Object?.keys(apiData)?.length < 0) return;
    let arrOfDocuments = [];
    if (apiData && Object?.keys(apiData)?.length > 0) {
      for (const key in localAssetsObj) {
        const element = apiData[key];
        arrOfDocuments.push({ ...element, key: key });
      }
    }

    return arrOfDocuments;
  }
  let documentsData = getObjecstWithName({
    apiData: legalDocuments?.documents?.documents,
  });

  let addedWithGermanLabel = useMemo(() => {
    return documentsData
      ?.map((item) => ({
        ...item,
        germanLabel: translator(`caseDetail.legalDocs.${item.key}`),
      }))
      .filter((item) =>
        item.germanLabel?.toLowerCase().includes(searchAssets?.toLowerCase()),
      );
  }, [documentsData, searchAssets]);

  const columns = [
    {
      title: legalDocsValuesTrans.key,
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => {
        return index + 1;
      },
      width: "8%",
      align: "left",
    },
    {
      title: legalDocsValuesTrans.name,
      dataIndex: "name",
      key: "name",
      width: "20%",
      align: "left",
      ellipsis: true,
      render: (value, record) => {
        return legalDocsValuesTrans[record.key];
      },
    },
    {
      title: legalDocsValuesTrans.lastUpdated,
      dataIndex: "lastUpdated",
      key: "lastUpdated",
      width: "17%",
      align: "left",
      render: (value, record) => {
        return value !== "None" && value ? dateTimeFormatted(value) : "";
      },
    },
    {
      title: legalDocsValuesTrans.updatedBy,
      dataIndex: "authorName",
      key: "authorName",
      width: "20%",
      ellipsis: true,
      align: "center",
      render: (value, record) => {
        return value === "None" ? "" : value;
      },
    },
    {
      title: legalDocsValuesTrans.fileCount,
      dataIndex: "fileCount",
      key: "fileCount",
      width: "14%",
      align: "center",
    },
    {
      title: legalDocsValuesTrans.status,
      dataIndex: "status",
      key: "status",
      width: "7%",
      align: "center",
      render: (_, record) => {
        const isUploaded = !!record.isUploaded;

        return isUploaded ? <CircleTickIcon /> : <EmptyCircleIcon />;
      },
    },

    {
      title: legalDocsValuesTrans.action,
      key: "action",
      width: "14%",
      align: "center",
      render: (_, record) => {
        const isUploaded = !!record.isUploaded;

        return (
          <Space size="middle">
            <button
              className={styles.viewDetailsBtn}
              onClick={() => onUploadIconClick(record)}
            >
              {isUploaded ? (
                <img
                  src="/assets/icons/eye.svg"
                  alt="Icon"
                  height={15}
                  width={15}
                />
              ) : (
                <UploadFileIcon style={{ height: "12px" }} />
              )}
            </button>
          </Space>
        );
      },
    },
  ];

  const [studioFinalData, setStudioFinalData] = useState([
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10,
  ]);

  function onUploadIconClick(fileDocument) {
    setSelectedDocument(fileDocument);
    setOpenUploadFileModal(true);
  }
  const totalData = Array(20)
    .fill(0)
    ?.map((item, index) => {
      return {
        key: index + 1,
        filename: `2025-254-AS12`,
        updatedBy: "Anna Müller",
        lastUpdated: "2025-08-14 08:01:48",
        numberOfFiles: "3",
        status: "completed",
      };
    });
  useEffect(() => {
    const filteredData = totalData?.filter((item) =>
      item.username?.toLowerCase()?.includes(deboucedSearch),
    );
    setStudioFinalData(filteredData);
  }, [deboucedSearch]);

  function handleChatSearch(e) {
    const searchedKey = e.target?.value?.toLowerCase();
    const filteredData = totalData.filter((item) =>
      item.username.toLowerCase().includes(searchedKey),
    );
    setStudioFinalData(filteredData);
  }
  function openCreateLicense() {
    navigate("/create-case");
  }
  function handleCloseModal() {
    setOpenUploadFileModal(false);
  }

  return (
    <div className={styles.tableContainer}>
      <div className={styles.tableWrapper}>
        <Spin spinning={isLoading}>
          <Table
            title={() => tableHeading}
            columns={columns}
            dataSource={addedWithGermanLabel}
            rowClassName={styles.row}
            scroll={{
              y: collapseOpen ? `calc(100dvh - 500px)` : `calc(100dvh - 280px)`,
            }} // Set the width for horizontal scrolling
            style={{ width: "100%", minHeight: "calc(100dvh - 180px)" }}
            className={styles.userListTable}
            sticky={true}
            // pagination={{
            //   position: ["bottomCenter"],
            //   // pageSize: pageSize,
            //   // current: currentPage,
            // }}
            pagination={false}
          />
        </Spin>
      </div>
      <UploadFilesModal
        open={openUploadFileModal}
        handleCloseModal={handleCloseModal}
        fileData={selectedDocument}
        refetchLegalDocs={refetchLegalDocs}
        refetchDetail={refetchDetail}
        refetchAllUploadedFiles={refetchAllUploadedFiles}
        dropdownsListObj={dropdownsListObj}
        refetchCount={refetchCount}
      />
    </div>
  );
};
